import React from 'react';
import './index.css';
import ReactDOM from 'react-dom/client';
import App from './App';
import UserStore from './store/UserStore';
import DeviceStore from './store/DeviceStore';
import BasketStore from './store/BasketStore'; // ← Проверьте этот импорт
import 'bootstrap/dist/css/bootstrap.min.css';

export const Context = React.createContext(null);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
    <Context.Provider value={{
        user: new UserStore(),
        device: new DeviceStore(),
        basket: new BasketStore() // ← Проверьте, что это есть
    }}>
        <App /> 
    </Context.Provider>
);
